import { getLocale } from "../runtime";

const sv_showmore = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Läs mer`
};

const showmore = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_showmore(inputs)
	return "showMore";
};

export { showmore as "showMore" };